import { Box, Icon, List, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import WorkplacesActions from 'modules/profile/components/Workplaces/WorkplacesActions'
import {
  ProfileEmployeeLocationEmployeesLocationFragment,
  ProfileEmployeeLocationFragment,
  ProfileEmployeeLocationWorkAreaFragment,
} from 'generated/resources/graphql'

interface Props {
  locationName: string
  isLocationDefault: boolean
  employeeId: string
  accessId: string
  locationId: string
  canAssignLocations: boolean
  defaultWorkArea?: ProfileEmployeeLocationWorkAreaFragment
  onDefaultLocationUpdated: (id: string) => void
  companyLocations?: ProfileEmployeeLocationFragment[]
  employeeLocations: ProfileEmployeeLocationEmployeesLocationFragment[]
  isEmployeeLocationWorkAreaEnabled: boolean
  isFeatureFlagsLoading?: boolean
  employeesLocation?: ProfileEmployeeLocationEmployeesLocationFragment | null
}

const WorkplacesListItem = ({
  locationName,
  isLocationDefault,
  employeeId,
  accessId,
  locationId,
  canAssignLocations,
  defaultWorkArea,
  onDefaultLocationUpdated,
  companyLocations,
  employeeLocations,
  isEmployeeLocationWorkAreaEnabled = false,
  isFeatureFlagsLoading = false,
  employeesLocation = null,
}: Props) => {
  const [open, toggle] = useToggle(false)

  const { navigation } = useNavigation()

  const getTo = navigation.settings.locations.locationsId.details.fullPath({ id: locationId })

  const defaultWorkAreaName = isEmployeeLocationWorkAreaEnabled
    ? defaultWorkArea?.workArea?.name
    : undefined

  const locationFullName =
    isEmployeeLocationWorkAreaEnabled && defaultWorkAreaName
      ? `${locationName}, ${defaultWorkAreaName}`
      : locationName

  return (
    <List.Item>
      <Box
        flexDirection="row"
        alignItems="center"
        width="full"
        justifyContent="spaceBetween"
        gap="s24"
      >
        <Box flexDirection="row" minWidth="none" gap="s8">
          {isLocationDefault && <Icon.Medium icon="star" />}

          <Tooltip
            attachment="middle left"
            targetAttachment="middle right"
            type="black"
            size="small"
            open={open}
            toggle={toggle}
          >
            <List.Title ellipsis>{locationFullName}</List.Title>
            <div>{locationFullName}</div>
          </Tooltip>
        </Box>
        <WorkplacesActions
          to={getTo}
          employeeId={employeeId}
          accessId={accessId}
          isLocationDefault={isLocationDefault}
          locationId={locationId}
          canAssignLocations={canAssignLocations}
          companyLocations={companyLocations}
          employeeLocations={employeeLocations}
          onDefaultLocationUpdated={onDefaultLocationUpdated}
          isEmployeeLocationWorkAreaEnabled={isEmployeeLocationWorkAreaEnabled}
          isFeatureFlagsLoading={isFeatureFlagsLoading}
          employeesLocation={employeesLocation}
        />
      </Box>
    </List.Item>
  )
}

export default WorkplacesListItem
